import { useIntersect, useScroll, useTexture, Text, createInstances, Float, Sparkles, Center } from "@react-three/drei"
import { mainStore } from "../../store"
import { useFrame, useThree } from "@react-three/fiber"

import { Suspense, useEffect, useMemo, useRef } from "react"
import { __ } from "../../utils"
import * as THREE from 'three'




import Team from "../../components/team.jsx"


import TextRight from "../../components/textRight.jsx"
import TextLeft from "../../components/textLeft.jsx"
import TextCenter from "../../components/textCenter.jsx"
import TestVivo from "../../components/image/TestVivo.jsx"
import Creche from "../../components/image/Creche.jsx"
import { Rugby } from "../../components/models/rugby/model.jsx"
import UP3 from "../../components/image/UP3.jsx"
import ADN from "../../components/image/ADN.jsx"
import DD from "../../components/image/DD.jsx"
import Biopsie from "../../components/videos/Biopsie.jsx"
import { IBPN } from "../../components/models/IBPN/model.jsx"
import Microbiote from "../../components/image/Microbiote.jsx"
import { Softcare } from "../../components/models/Softcare/model.jsx"
import UPB from "../../components/image/UPB.jsx"
import UPA from "../../components/image/UPA.jsx"
import IA from "../../components/image/IA.jsx"
import Nectarobiote from "../../components/image/Nectarobiote.jsx"


export default function BodyChapterFour() {
    // Utils
    const data = useScroll()
    const { width, height } = useThree((state) => state.viewport)


    // Store
    const colors = mainStore.useStore(s => s.colors)
    const fonts = mainStore.useStore(s => s.fonts)
    const scrollMap = mainStore.useStore(s => s.scrollMap)
    const currentChapter = mainStore.useStore((s) => s.current)
    const isUiHidden = mainStore.useStore((s) => s.isUiHidden)
    const preventChapterUpdate = mainStore.useStore(s => s.preventChapterUpdate)


    const lang = mainStore.useStore(s => s.lang)



    const chapters = mainStore.useStore(s => s.chapters)
    const chapter = chapters[3]


    // Refs
    const rugbyRef = useRef()
    const IBPNRef = useRef()

    /**
     * Shaders
     * */




    useFrame(({ clock, delta }) => {

        rugbyRef.current.rotation.z = 0.9 + (clock.getElapsedTime() * 0.2)
        IBPNRef.current.rotation.y = 0 + (clock.getElapsedTime() * 0.15)
        // Chapter auto selector
        // if (data.scroll.current > scrollMap.one && data.scroll.current <= scrollMap.two && !currentChapter.dates.includes(1991) && isUiHidden && !preventChapterUpdate) {
        //     mainStore.selectChapter('UNICITÉ', [1990, 1999])
        // }


        if (data.scroll.current > chapter.start && data.scroll.current <= scrollMap.four) {

            if (!currentChapter.dates.includes(2010) || !currentChapter.dates.includes(2020)) {
                mainStore.preventChapterUpdate(true)
                mainStore.selectChapter(chapter.name[lang === 'fr' ? lang : 'en'], chapter.dates, chapter.start)
                setTimeout(() => mainStore.preventChapterUpdate(false), 1000)

            }
        }
    })




    return <>
        <group position={[0, -71, 0]}>
            <group position={[0, -0.9, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={-0.4}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2010
                </TextLeft>
                <Creche scale={1.2} position={[-0.5, -0.9, 0]} />
                <group position={[0, -0.6, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}

                                    offsetX={0.88}
                                    offsetY={-0.2}>
                                    Crèche inter-entreprises
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Pour faciliter l’équilibre vie privée / professionnelle des jeunes parents parmi les collaborateurs, l'entreprise initie la création d’une crèche inter-entreprise, située aux portes de SILAB.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Inter-company nursery
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    To facilitate the work-life balance of young parents among its collaborators, the company initiates the creation of an inter-company nursery, located on the outskirts of SILAB.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -2.5, 0]}>
                    <group position={[-2.5, 1.7, 2]} rotation={[0.9, 0.8, 0.8]}>

                        <Rugby ref={rugbyRef} scale={0.4} position={[-1.1, -0.5, 2]} />

                    </group>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.88}
                                    offsetY={-0.2}>
                                    Partenariat avec le CABCL Association
                                </TextRight>

                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Le partenariat de SILAB avec l’équipe de rugby locale débute par un soutien financier de son centre de formation.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    exposant={"st"}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Partnership with the CABCL Association
                                </TextRight>

                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.48}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB's partnership with the local rugby team begins with financial support for its training center.
                                </TextRight>
                            </>
                        )
                    }
                </group>



            </group>
            <group position={[0, -4.5, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={-0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2011
                </TextLeft>
                <UP3 scale={1.2} position={[-0.5, -0.9, 0]} />
                <group position={[0, -0.6, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={"e"}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    3   atelier de production
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Cette unité allie flexibilité et automatisme afin de faire face à l’augmentation des volumes. Il a notamment été pensé de façon à optimiser l’ergonomie des postes de travail.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    exposant={"rd"}
                                    offsetX={.07}
                                    offsetY={-0.2}>
                                    3   production unit
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    This unit combines flexibility and automation to cope with increasing volumes. In particular, it has been designed to optimize workstation ergonomics.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -1.5, 0]}>

                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.16}
                                    positionY={-.2}
                                    exposant={'Data science'}
                                    expFont={fonts.cm.legend}
                                    scale={1}
                                    offsetX={0.58}
                                    offsetY={-0.15}>
                                    Unité de
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Cette équipe travaille en étroite collaboration avec le département R&D afin de développer des méthodes de quantification et d’analyses pointues.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Data science unit
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    This team works closely with the R&D department to develop cutting-edge quantification and analysis methods.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
            </group>

            <group position={[0, -7.5, 0]}>
                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2012
                </TextRight>
                <ADN scale={1.1} position={[-3, -0.5, 0.5]} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.88}
                                    offsetY={-0.2}>
                                    Travaux de recherche liés à l’épigénétique
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.55}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Ce programme de recherche intensif sur l’épigénétique de la peau et du cheveu met en évidence les mécanismes impliqués dans la relation épigénome / vieillissement cutané par l’utilisation des sciences OMICS.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    exposant={"st"}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Research work on epigenetics
                                </TextRight>

                                <TextRight
                                    maxWidth={2.4}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.53}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    This intensive research program on skin and hair epigenetics highlights the mechanisms involved in the epigenome/cutaneous aging relationship, using OMICS sciences.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.8, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.88}
                                    offsetY={-0.2}>
                                    Création de SILAB South America
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    nouvelle filiale brésilienne localisée à São Paulo, pour la promotion des actifs et le management des distributeurs en zone sud-américaine.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Creation of SILAB South America
                                </TextRight>

                                <TextRight
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    a new Brazilian subsidiary based in São Paulo, to promote active ingredients and manage distributors in South America.
                                </TextRight>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -9.5, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={-0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2013
                </TextLeft>
                <DD scale={1.2} position={[-0.5, -0.9, 0]} />
                <group position={[0, -0.4, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={"er"}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    1   rapport de développement durable
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Les engagements et initiatives de l’entreprise sont détaillés et communiqués dans un rapport dédié.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    exposant={"st"}
                                    offsetX={.055}
                                    offsetY={-0.2}>
                                    1   sustainable development report
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    The company's commitments and initiatives are detailed and communicated in a dedicated report.
                                </TextLeft>
                            </>
                        )
                    }
                </group>

            </group>
            <group position={[0, -11, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2014
                </TextLeft>
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Création de SILAB South East Asia
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    à Singapour pour renforcer sa position sur toute la zone Asie-Pacifique.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Creation of SILAB South East Asia
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    in Singapore to strengthen its position throughout the Asia-Pacific region.
                                </TextLeft>
                            </>
                        )
                    }
                </group>

            </group>
            <group position={[0, -12.3, 0]}>
                <UPB scale={1.4} position={[-3.3, -0.5, 0.5]} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={1.6}
                                    lineHeight={1}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'er'}
                                    scale={1}
                                    offsetX={-1.43}
                                    offsetY={0.1}>
                                    1   atelier de production par biotechnologies
                                </TextRight>

                                <TextRight
                                    maxWidth={1.6}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.55}
                                    scale={1}
                                    offsetX={-1.01}
                                    offsetY={-0.27}>
                                    SILAB ouvre sa première ligne industrielle de culture et de bioguidage de micro-organismes sur son site.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={2}
                                    lineHeight={1}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'st'}
                                    scale={1}
                                    offsetX={-1.74}
                                    offsetY={0.1}>
                                    1   biotechnology production workshop

                                </TextRight>

                                <TextRight
                                    maxWidth={1.6}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.958}
                                    offsetY={-0.27}>
                                    SILAB opens its first production line dedicated to biotechnologies on its site.
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.8, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'res'}
                                    scale={1}
                                    offsetX={-2}
                                    offsetY={-0.07}>
                                    1    évaluations EcoVadis et Sedex
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB, dans une démarche volontaire et de transparence, est évaluée par des organismes tiers sur sa politique RSE.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'st'}
                                    scale={1}
                                    offsetX={-2.1}
                                    offsetY={-0.07}>
                                    1   EcoVadis and Sedex assessments
                                </TextRight>

                                <TextRight
                                    maxWidth={2.}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB, as part of a voluntary and transparent approach, is assessed by third-party organizations on its CSR policy.
                                </TextRight>
                            </>
                        )
                    }
                </group>

            </group>
            <group position={[0, -14.5, 0]}>
                <Biopsie scale={1.3} position={[1, -0.9, 1.2]} />
                <group position={[0, -0.2, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.16}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.88}
                                    offsetY={-0.2}>
                                    Biopsies optiques
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB participe au développement de la microscopie Raman utilisée pour caractériser l’état de sécheresse de la peau.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Optical biopsies
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB participates in the development of Raman microscopy used to characterize skin dryness.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.95, 0]}>
                    <Team scale={0.6} offsetNumber={-0.09} position={[-width * (0.2 + 0.03), .6, 2]}>
                        250
                    </Team>
                </group>
            </group>
            <group position={[0, -16.55, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2015
                </TextLeft>
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Création d’une charte éthique
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    afin de recenser ses engagements éthiques et de les communiquer.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Creation of an ethics charter
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    to list and communicate its ethical commitments.
                                </TextLeft>
                            </>
                        )
                    }
                </group>

            </group>
            <group position={[0, -18., 0]}>
                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2016
                </TextRight>
                <IBPN ref={IBPNRef} scale={1.1} position={[-2, -0.5, 0.5]} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    positionX={-.005}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={0.01}
                                    offsetY={-0.07}>
                                    IBPN Technology
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    positionY={-.45}
                                    exposant={['®', 'Interpenetrating biopolymer network technology']}
                                    expFont={fonts.ms.italic}

                                    expOffsetArray={[
                                        [-0.06, 0.09],
                                        [-1.571, 0.175]
                                    ]}
                                    scale={1}
                                >
                                    Cette technologie inédite (                                                                                                ) est à l’origine du développement du cinquième actif phytotenseur : FILMEXEL   .
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    positionX={-.005}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={0.01}
                                    offsetY={-0.07}>
                                    IBPN Technology
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={-0.06}
                                    offsetY={-0.36}>
                                    This unique technology (Interpenetrating biopolymer network technology) is behind the development of the fifth phytotensor active ingredient: FILMEXEL   .
                                </TextRight>
                            </>
                        )
                    }
                </group>
                <group position={[0, -.9, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}

                                    scale={1}
                                    offsetX={0.01}
                                    offsetY={-0.07}>
                                    Charte des achats responsables
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.55}

                                    scale={1}
                                    offsetX={-0.06}
                                    offsetY={-0.36}>
                                    Les valeurs liées aux Droits de l’Homme, aux conditions de travail, à l’environnement et à l’éthique dans les relations commerciales ont été formalisées par SILAB dans une Charte des achats responsables.
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}


                                    scale={1}
                                    offsetX={0.01}
                                    offsetY={-0.07}>
                                    Responsible purchasing charter
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}

                                    scale={1}
                                    offsetX={-0.06}
                                    offsetY={-0.36}>
                                    SILAB has formalized its values relating to human rights, working conditions, the environment and ethical business practices in a Responsible purchasing charter.
                                </TextRight>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -20.55, 0]}>
                <Microbiote position={[0, -0.5, 0]} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Programme microbiote cutané
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Le département R&D lance un programme de recherche ambitieux dédié à l’exploration du microbiote cutané sur la peau saine et la peau fragilisée.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Skin microbiota program
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    The R&D department launches an ambitious research program dedicated to exploring cutaneous microbiota in healthy and compromised skin.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.7, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Laboratoire d’immunologie
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    L’immunité cutanée s’inscrit dans un programme de recherche continu qui permet d’inclure dans les développements l’étude de l’implication des cellules immunitaires avec le système cutané.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Immunology laboratory
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    Cutaneous immunity is part of an ongoing research program which allows developments to include the study of the involvement of immune cells with the cutaneous system.
                                </TextLeft>
                            </>
                        )
                    }
                </group>

            </group>
            <group position={[0, -24.5, 0]}>

                <Softcare position={[1.6, 0.6, 2]} scale={0.25} />


                <TextCenter
                    maxWidth={4}
                    fontsOw={fonts.cm.title}
                    fontSize={0.16}
                    exposantHeight={0.07}
                    positionY={-.2}
                    scale={1}
                    offsetX={0.07}
                    offsetY={-0.2}>
                    {
                        __("SILAB Softcare, le soin des peaux fragilisées", "SILAB Softcare, solutions for compromised skin")
                    }
                </TextCenter>

                <TextCenter
                    maxWidth={2.3}
                    fontsOw={fonts.ms.text}
                    fontSize={0.062}
                    lineHeight={1.4}
                    exposantHeight={0.05}
                    positionY={-.45}
                    scale={1}
                    offsetX={-0.43}
                    offsetY={-0.4}>
                    {
                        __("Ce département développe des actifs naturels sous forme de poudres sans conservateurs à destination de soins dermo-cosmétiques et dermatologiques.", "This department develops natural active ingredients in preservative-free powder form for dermocosmetic and dermatological care.")
                    }
                </TextCenter>

                {
                    __(

                        <>
                            <TextCenter
                                maxWidth={2.3}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.8}
                                exposant={"®"}
                                scale={1}
                                offsetX={0.14}
                                offsetY={-0.8}>
                                Son premier produit, AD-RESYL   , prévient les signes cliniques de la dermatite atopique et prolonge les périodes de rémission.
                            </TextCenter>
                        </>,
                        <>
                            <TextCenter
                                maxWidth={2.3}
                                fontsOw={fonts.ms.text}
                                fontSize={0.062}
                                lineHeight={1.4}
                                exposantHeight={0.05}
                                positionY={-.8}
                                exposant={"®"}
                                scale={1}
                                offsetX={0.035}
                                offsetY={-0.8}>
                                Its first product, AD-RESYL  , prevents the clinical signs of atopic dermatitis and prolongs periods of remission.
                            </TextCenter>
                        </>

                    )
                }



            </group>
            <group position={[0, -27, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2017
                </TextLeft>
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Régénération cutanée
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    La Recherche SILAB étudie les mécanismes biologiques liés à l’interconnectivité cellulaire. L’objectif est de caractériser l’implication des systèmes cutané, immunitaire et vasculaire dans le processus régénératif ainsi que leurs évolutions au cours du vieillissement.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Skin regeneration
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB Research studies the biological mechanisms linked to cellular interconnectivity. The aim is to characterize the involvement of the cutaneous, immune and vascular systems in the regenerative process, and how they evolve during the aging process.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -0.8, 0]}>
                    <IA scale={1.1} />
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.16}
                                    expFont={fonts.cm.legend}
                                    exposant={'data sciences'}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.6}
                                    offsetY={-0.15}>
                                    Intelligence artificielle et
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposant={['machine learning', 'deep learning', 'data science.']}
                                    expOffsetArray={[
                                        [0.96, -.40],
                                        [1.625, -.40],
                                        [1.132, -.486]
                                    ]}
                                    expFont={fonts.ms.italic}
                                    exposantHeight={0.062}
                                    positionY={-.4}
                                    scale={1}

                                >
                                    Les compétences de SILAB en                                     et                              ont été rassemblées au sein d’une unité
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={1.04}
                                    offsetY={-0.2}>
                                    Artificial intelligence and data sciences
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.4}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    SILAB's expertise in machine learning and deep learning has been brought together in a data science unit.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -1.4, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.16}
                                    expFont={fonts.cm.legend}
                                    positionY={-.2}
                                    scale={1}
                                >
                                    Implication au sein de la Cosmetic Valley
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    positionY={-.4}
                                    scale={1}
                                >
                                    SILAB apporte une contribution active au service du développement de l’innovation cosmétique française à travers son engagement auprès de la Cosmetic Valley, initialement en tant que membre associé.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.16}
                                    expFont={fonts.cm.legend}
                                    positionY={-.2}
                                    scale={1}
                                >
                                    Involvement in Cosmetic Valley
                                </TextLeft>

                                <TextLeft
                                    maxWidth={2.3}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    positionY={-.4}
                                    scale={1}

                                >
                                    SILAB makes an active contribution to the development of French cosmetics innovation through its involvement with Cosmetic Valley, initially as an associate member.
                                </TextLeft>
                            </>
                        )
                    }
                </group>

            </group>
            <group position={[0, -30., 0]}>
                <TextRight
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2018
                </TextRight>
                <Nectarobiote position={[-3.2, -0.3, 0]} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={-1.42}
                                    offsetY={-0.09}>
                                    Du Nectarobiote   au microbiote cutané
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.55}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={-.73}
                                    offsetY={-0.29}>
                                    La Recherche SILAB s’est bio-inspirée du Nectarobiote   , ensemble des micro-organismes contenus dans le nectar des fleurs, pour identifier des matières premières d’intérêt.
                                </TextRight>
                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    positionY={-.88}
                                    scale={1}
                                    exposant={['®', 'Metschnikowia reukaufii', 'Hoya carnosa']}
                                    expOffsetArray={[
                                        [-0.05, .27],
                                        [-1.66, .172],
                                        [-0.45, .087]
                                    ]}
                                    expFont={fonts.ms.italic}
                                >
                                    Ces découvertes conduisent notamment au développement de ECOBIOTYS   , en prélevant la levure                                                 , dans le nectar de la fleur de porcelaine                            .
                                </TextRight>
                            </>,
                            // EN
                            <>
                                <TextRight
                                    maxWidth={4}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={-1.23}
                                    offsetY={-0.09}>
                                    From Nectarobiota  to skin microbiota
                                </TextRight>

                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={-.5}
                                    offsetY={-0.275}>
                                    SILAB Research has been bio-inspired by the Nectarobiota   , a collection of micro-organisms contained in flower nectar, to identify raw materials of interest.
                                </TextRight>
                                <TextRight
                                    maxWidth={2.5}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.062}
                                    positionY={-.78}
                                    scale={1}
                                    exposant={['®', 'Metschnikowia reukaufii', 'Hoya carnosa']}
                                    expOffsetArray={[
                                        [-0.58, .27],
                                        [-1.985, .172],
                                        [-0.445, .087]
                                    ]}
                                    expFont={fonts.ms.italic}
                                >
                                    These discoveries lead to the development of ECOBIOTYS   , by sampling the yeast                                                  from the nectar of the porcelain flower                                       .
                                </TextRight>
                            </>
                        )
                    }
                </group>
            </group>
            <group position={[0, -31.5, 0]}>
                <TextLeft
                    maxWidth={4.2}
                    fontSize={0.26}
                    positionY={0.2}
                    positionZ={0}
                    fontsOw={fonts.ms.title}
                    depthWrite={false}
                >
                    2019
                </TextLeft>
                <UPA scale={1.4} position={[-1, -1.2, 0]} />
                <group position={[0, -0., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Unité de production de poudres par atomisation
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.6}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    de haute technologie et automatisée. Le bâtiment, comprenant la tour d’atomisation, mesure 20 mètres de haut et possède une superficie de 1 800 m². L’internalisation de cette technologie industrielle permet à SILAB de proposer ses actifs sous forme de poudre sans conservateurs.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Spray-drying production unit
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.45}
                                    scale={1}
                                    offsetX={-0.43}
                                    offsetY={-0.4}>
                                    of high technology and automated. The building, which includes the spray-drying tower, is 20 meters high and covers an area of 1,800 m². By bringing this industrial technology in-house, SILAB is able to offer its own active ingredients in preservative-free powders.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -1., 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2.2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Unité de production de films secs
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.43}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={1.355}
                                    offsetY={-0.6}>
                                    SILAB a mis au point une unité de production « pilote » pour accompagner la Recherche sur sa technologie révolutionnaire de diffusion d’actifs dans la peau : SILAFILM   .
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Dry film production unit
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.43}
                                    exposant={'®'}
                                    scale={1}
                                    offsetX={1.085}
                                    offsetY={-0.6}>
                                    SILAB has developed a "pilot" production unit to support Research into its revolutionary technology for diffusing active ingredients into the skin: SILAFILM   .
                                </TextLeft>
                            </>
                        )
                    }
                </group>
                <group position={[0, -1.7, 0]}>
                    {
                        __(
                            //FR
                            <>
                                <TextLeft
                                    maxWidth={2.2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Partenariat avec la CCI de Brive
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.43}
                                    scale={1}
                                    offsetX={1.355}
                                    offsetY={-0.6}>
                                    Xavier GAILLARD, anciennement directeur général à la stratégie (et actuellement président du conseil de surveillance), est élu au conseil d’administration de la Chambre de commerce et d’industrie de Brive.
                                </TextLeft>
                            </>,
                            // EN
                            <>
                                <TextLeft
                                    maxWidth={2.2}
                                    fontsOw={fonts.cm.title}
                                    fontSize={0.16}
                                    lineHeight={1}
                                    exposantHeight={0.07}
                                    positionY={-.2}
                                    scale={1}
                                    offsetX={0.07}
                                    offsetY={-0.2}>
                                    Partnership with Brive CCI
                                </TextLeft>
                                <TextLeft
                                    maxWidth={2}
                                    fontsOw={fonts.ms.text}
                                    fontSize={0.062}
                                    lineHeight={1.4}
                                    exposantHeight={0.05}
                                    positionY={-.43}

                                    scale={1}
                                    offsetX={1.085}
                                    offsetY={-0.6}>
                                    Xavier Gaillard, formerly managing director for strategy (and currently chairman of the supervisory board), is elected to the board of directors of Brive Chamber of commerce & industry.
                                </TextLeft>
                            </>
                        )
                    }
                </group>
            </group>

        </group>
    </>
}